export enum GroupSectionEvents {
  allGroupsTabButtonClicked = 'All Groups Tab Button Clicked',
  allGroupsTabViewed = 'All Groups Tab Viewed',
  mySectionsTabButtonClicked = 'My Sections Tab Button Clicked',
  mySectionsTabViewed = 'My Sections Tab Viewed',
  weeklyViewTabButtonClicked = 'Weekly View Tab Button Clicked',
  weeklyViewTabViewed = 'Weekly View Tab Viewed',
  archiveTabButtonClicked = 'Archive Tab Button Clicked',
  archiveTabViewed = 'Archive Tab Viewed',
  createGroupV2ButtonClicked = 'Create Group Button Clicked',
  createGroupModalViewed = 'Create Group Modal Viewed',
  createGroupSaveChangesButtonClicked = 'Create Group Save Changes Button Clicked',
  createGroupCancelButtonClicked = 'Create Group Cancel Button Clicked',
  searchGroupInputClicked = 'Search Group Input Clicked',
  groupListCardClicked = 'Group List Card Clicked',
  groupClassDetailsDrawerViewed = 'Group Class Details Drawer Viewed',
  editGroupButtonClicked = 'Edit Group Button Clicked',
  editGroupModalViewed = 'Edit Group Modal Viewed',
  editGroupSaveChangesButtonClicked = 'Edit Group Save Changes Button Clicked',
  editGroupCancelButtonClicked = 'Edit Group Cancel Button Clicked',
  addSectionButtonClicked = 'Add Section Button Clicked',
  addSectionModalViewed = 'Add Section Modal Viewed',
  addSectionSaveChangesButtonClicked = 'Add Section Save Changes Button Clicked',
  addSectionCancelButtonClicked = 'Add Section Cancel Button Clicked',
  editSectionKebabMenuButtonClicked = 'Edit Section Kebab Menu Button Clicked',
  editSectionModalViewed = 'Edit Section Modal Viewed',
  cancelSectionKebabMenuButtonClicked = 'Cancel Section Kebab Menu Button Clicked',
  editSectionSaveChangesButtonClicked = 'Edit Section Save Changes Button Clicked',
  editSectionCancelButtonClicked = 'Edit Section Cancel Button Clicked',
  cancelSectionConfirmButtonClicked = 'Cancel Section Confirm Button Clicked',
  cancelSectionBackButtonClicked = 'Cancel Section Back Button Clicked',
  registerUserModalGroupsViewed = 'Register User Modal - Groups Viewed',
  registerUserModalCancelButtonClicked = 'Register User Modal - Cancel Button Clicked',
  registerUserModalGroupsContinueButtonClicked = 'Register User Modal - Groups Continue Button Clicked',
  registerUserModalGroupSelected = 'Register User Modal - Group Selected',
  registerUserModalSectionsViewed = 'Register User Modal - Sections Viewed',
  registerUserModalSectionsBackButtonClicked = 'Register User Modal - Sections Back Button Clicked',
  registerUserModalSectionsContinueButtonClicked = 'Register User Modal - Sections Continue Button Clicked',
  registerUserModalSectionSelected = 'Register User Modal - Section Selected',
  registerUserModalConfirmationViewed = 'Register User Modal - Confirmation Viewed',
  registerUserModalConfirmationBackButtonClicked = 'Register User Modal - Confirmation Back Button Clicked',
  registerUserModalRegisterUserButtonClicked = 'Register User Modal - Register User Button Clicked',
}
